/* Be'Sycle atelier tracking robust - installed 20260902T221946Z
 * Tracks non-personal local/conversion clicks for GA4.
 */
(function () {
  var measurementId = 'G-4QJ78FGTWQ';
  var scriptId = 'besycle-ga4-atelier-gtag';
  if (!window.dataLayer) window.dataLayer = [];
  window.gtag = window.gtag || function(){ window.dataLayer.push(arguments); };
  if (!document.getElementById(scriptId)) {
    var s = document.createElement('script');
    s.async = true;
    s.id = scriptId;
    s.src = 'https://www.googletagmanager.com/gtag/js?id=' + encodeURIComponent(measurementId);
    document.head.appendChild(s);
    window.gtag('js', new Date());
    window.gtag('config', measurementId, { send_page_view: false });
  }

  function cleanPath(url) {
    try { return new URL(url, location.origin).pathname; }
    catch (e) { return String(url || '').split('?')[0].split('#')[0]; }
  }
  function classify(anchor) {
    var href = anchor.getAttribute('href') || '';
    var text = (anchor.textContent || '').trim().replace(/\s+/g, ' ').slice(0, 80);
    var hrefLower = href.toLowerCase();
    var path = cleanPath(href);
    if (hrefLower.indexOf('tel:') === 0) return { name: 'click_phone', label: text || 'Téléphone', destination: 'phone', delay: true };
    if (hrefLower.indexOf('google.com/maps') !== -1 || hrefLower.indexOf('maps.app.goo.gl') !== -1) return { name: 'click_google_maps', label: text || 'Google Maps', destination: 'google_maps', delay: true };
    if (path === '/pages/contact') return { name: 'click_contact', label: text || 'Contact', destination: path, delay: false };
    if (path === '/pages/reparation-trottinette-electrique-essonne' || path === '/collections/services-reparations') return { name: 'click_repair_services', label: text || 'Réparations', destination: path, delay: false };
    return null;
  }
  function track(anchor, info) {
    var payload = {
      event_category: 'atelier',
      event_label: info.label,
      link_url: anchor.href || anchor.getAttribute('href') || '',
      link_text: info.label,
      page_location: location.href,
      page_path: location.pathname,
      destination: info.destination,
      transport_type: 'beacon',
      event_callback: function () {},
      event_timeout: 900
    };
    try {
      if (typeof window.gtag === 'function') window.gtag('event', info.name, payload);
      window.dataLayer.push(Object.assign({ event: info.name }, payload));
    } catch (e) {}
  }
  document.addEventListener('click', function (event) {
    var anchor = event.target && event.target.closest ? event.target.closest('a[href]') : null;
    if (!anchor || anchor.dataset.besycleTrackingBypass === 'true') return;
    var info = classify(anchor);
    if (!info) return;
    track(anchor, info);
    var href = anchor.getAttribute('href') || '';
    var target = anchor.getAttribute('target') || '';
    var isModified = event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0;
    if (!info.delay || target === '_blank' || isModified) return;
    event.preventDefault();
    anchor.dataset.besycleTrackingBypass = 'true';
    window.setTimeout(function () {
      if (href.toLowerCase().indexOf('tel:') === 0 || href.toLowerCase().indexOf('mailto:') === 0) {
        window.location.href = href;
      } else {
        anchor.click();
      }
    }, 180);
  }, true);
})();
